// extracted by mini-css-extract-plugin
module.exports = {"style":"_1WlVBkUQ5eur-9flbYobVm"};